import { render } from "./BaseContentContainer.vue?vue&type=template&id=68d7ce83"
const script = {}

import "./BaseContentContainer.vue?vue&type=style&index=0&id=68d7ce83&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__